// // 日程表类型
// // 存放日程安排
// function Schedule() {
//   // this.cycleCount = 2; // 每日更换的班次
//   // this.teamCount = 3; // 团队数量
//   // this.startDate = new Date(); // 起始日期
//   // this.endDate = null; // 终止日期

//   this._addProperty('cycleCount', 2, positiveInteger);
//   this._addProperty('teamCount', 3, positiveInteger);
//   this._addProperty('startDate', new Date(), value => this._checkParameter(value, Date));
//   this._addProperty('endDate', null, value => this._checkParameter(value, Date));
// }

// Object.assign(Schedule.prototype, {

//   /**
//    * 返回两个日期中间的所有日期，包含开头和结尾
//    * @param {Date} earlyDate 最早日期
//    * @param {Date} lateDate 最晚日期
//    */
//   buildPlan(earlyDate, lateDate = earlyDate) {
//     let plan = this.datesInRange(earlyDate, lateDate);
//     let result = [];
//     for (let day of plan) {
//       result.push({
//         date: day,
//         order: this.buildDatePlan(day),
//       })
//     }
//     return result;
//   },

//   /**
//    * 返回两个日期中间的所有日期，包含开头和结尾
//    * @param {Date} earlyDate 最早日期
//    * @param {Date} lateDate 最晚日期
//    */
//   datesInRange(earlyDate, lateDate = earlyDate) {
//     const result = [];
//     const diff = this.diffDate(lateDate, earlyDate);
//     if (diff < 0) {
//       return null;
//     }
//     let current = new Date(earlyDate);
//     for (let i = 0; i <= diff; i++) {
//       result.push(new Date(current));
//       current.setDate(current.getDate() + 1);
//     }
//     return result;
//   },

//   /**
//    * 返回 date 所指定的那一天的安排
//    * 警告：这里隐含了一个假设，即开工后到结束前排班是没有中断过的。
//    *      这对于当前需求是正确的，但是如果有变更需要调整这里。
//    * @param {Date} date  要获取的日期（时分秒无影响） 
//    */
//   buildDatePlan(date, firstStartTime) {
//     // 输入参数校验
//     this._checkParameter(date, Date);

//     if (!this.ifInRangeStartEnd(date)) {
//       return null;
//     }

//     // 计算 date 和 起始日期之间的天数差
//     const diff = this.diffDate(date, this.startDate);
//     const cycleCount = this.cycleCount;
//     const result = [];
//     for (let i = cycleCount * diff; i < cycleCount * (diff + 1); i++) {
//       result.push(i % this.teamCount);
//     }
//     return result;
//     // if (diff < 0) { // 在起始日期之前
//     //   return null;
//     // }

//     // // 优化加速，减少后续循环的次数
//     // // 获取当前的排班的循环周期
//     // const period = this.period();
//     // // 相对天数差
//     // diff = diff % period;

//     // for (let i = 0; i < diff; i++) {

//     // }
//   },

//   /**
//    * 获取两个日期之间的天数差
//    */
//   diffDate(date1, date2) {
//     this._checkParameter(date1, Date);
//     this._checkParameter(date2, Date);

//     // 获取规范化后的日期对应的时间
//     const formalizeTime = (date) => {
//       return this._formalizeDate(date).getTime();
//     }
//     return Math.floor((formalizeTime(date1) - formalizeTime(date2)) / 1000 / 3600 / 24);
//   },

//   /**
//    * 判断 date 是否在起止日期的范围中
//    * @param {Date} date 日期
//    */
//   ifInRangeStartEnd(date) {
//     if (this.diffDate(date, this.startDate) < 0) { // 早于起始日期
//       return false;
//     }
//     if (this.endDate && this.diffDate(date, this.endDate) > 0) { // 晚于终止日期
//       return false;
//     }
//     return true;
//   },

//   /**
//    * 规范化日期
//    * 返回 时、分、秒 被设置为 0，而 年、月、日 相同的日期
//    * @param {Date} date 需要被正规化的日期
//    * @returns {Date}
//    */
//   _formalizeDate(date) {
//     this._checkParameter(date, Date);

//     return new Date(date.getFullYear(), date.getMonth(), date.getDate());
//   },

//   /**
//    * 断言 value instanceof type
//    * @param {*} value 待检查的参数
//    * @param {Function} type 类型
//    */
//   _checkParameter(value, type) {
//     if (!(toObj(value) instanceof type)) {
//       throw new Error(value + ' is not instanceof ' + type)
//     }
//     return value;
//   },

//   /**
//    * 创建对象的访问器属性
//    * （比及直接设置属性，使用该函数可以对输入参数的合法性进行校验）
//    * @param {String} name 属性名称
//    * @param {*} _value 属性的初始值
//    * @param {Function} setter 设置的回调函数
//    * @param {Function} getter 取值的回调函数
//    */
//   _addProperty(name, _value, setter = identity, getter = identity) {
//     this._checkParameter(name, String);
//     this._checkParameter(setter, Function);
//     this._checkParameter(getter, Function);
//     // let _value;
//     Object.defineProperty(this, name, {
//       configurable: true,
//       enumerable: true,
//       get: () => {
//         return getter.call(this, _value);
//       },
//       set: (value) => {
//         _value = setter.call(this, value, _value);
//       },
//     })
//   }
//   // /**
//   //  * 返回排班的循环周期
//   //  * 比如 3 班 2 倒
//   //  * (a,b); (c,a); (b,c);
//   //  * 三天一个循环，返回 3
//   //  */
//   // period() {
//   //   return Math.abs(this._teams / gcd(this._shifts, this._teams));
//   // },
// })

// /**************** 辅助函数 ******************/
// // /**
// //  * 最大公约数
// //  * @param {Number} a 
// //  * @param {Number} b 
// //  */
// // function gcd(a, b) {
// //   a = parseInt(a);
// //   b = parseInt(b);
// //   return b === 0 ? a : gcd(b, a % b);
// // }

// /**
//  * 返回相同值
//  */
// function identity(_) {
//   return _;
// }

// function toObj(value) {
//   switch (typeof value) {
//     case 'boolean':
//       return new Boolean(value);
//     case 'number':
//       return new Number(value);
//     case 'string':
//       return new String(value);
//     default:
//       return value;
//   }
// }

// /**
//  * 返回 value 转换可以转换到的正整数
//  * @param {*} value 
//  */
// function positiveInteger(value) {
//   value = parseInt(value);
//   if (typeof value !== 'number' || value <= 0) {
//     throw new Error('Value must be positive integer');
//     // return 1;
//   }
//   return value;
// }

// export default Schedule;


// /**************** 测试部分 ******************/
// // 仅在当前文件为入口文件时运行后续代码
// // 相当于 python 的 if __name__ == '__main__'
// if (require.main === module) {
//   // 断言
//   const assertEq = function (a, b) {
//     if (a instanceof Object && b instanceof Object) {
//       const keys = [...Object.keys(a), ...Object.keys(b)];

//       for (let k of keys) {
//         if (a[k] !== b[k]) {
//           throw new Error(a + ' 和 ' + b + '的' + k + '属性不同');
//         }
//       }
//     } else if (a !== b) {
//       throw new Error(a + '!==' + b)
//     }
//   }
//   // 测试
//   let schedule = new Schedule();
//   // 测试日期正规化
//   let date = new Date();
//   let formalDate = schedule._formalizeDate(date);
//   assertEq(date.getDate(), formalDate.getDate());
//   assertEq(date.getMonth(), formalDate.getMonth());
//   assertEq(date.getFullYear(), formalDate.getFullYear());
//   // 测试日期差计算函数
//   assertEq(schedule.diffDate(date, formalDate), 0);
//   assertEq(schedule.diffDate(new Date(2008, 1, 1), new Date(2008, 2, 1)), -29); // 闰年2月
//   assertEq(schedule.diffDate(new Date(2019, 2, 1), new Date(2018, 2, 1)), 365); // 平年365天
//   // // 测试 gcd
//   // assignEq(gcd(15, 18), 3);
//   // 测试 buildDatePlan()
//   assertEq(schedule.buildDatePlan(date), [0, 1]);
//   assertEq(schedule.buildDatePlan(new Date(date.getFullYear(),
//       date.getMonth(),
//       date.getDate() + 10)),
//     [2, 0]);
//   assertEq(schedule.buildDatePlan(new Date(date.getFullYear(),
//       date.getMonth(),
//       date.getDate() - 1)),
//     null); // 昨天还没开工

//   schedule.endDate = new Date(date.getFullYear(),
//     date.getMonth(),
//     date.getDate() + 1);
//   assertEq(schedule.buildDatePlan(new Date(date.getFullYear(),
//       date.getMonth(),
//       date.getDate() + 1)),
//     [2, 0]);
//   assertEq(schedule.buildDatePlan(new Date(date.getFullYear(),
//       date.getMonth(),
//       date.getDate() + 2)),
//     null);

//   // 综合测试
//   schedule.cycleCount = 3;
//   schedule.teamCount = 5;
//   schedule.startDate = new Date(2019, 1, 1); // 2 月 1 日 
//   schedule.endDate = new Date(2019, 2, 1); // 3 月 1 日 
//   // for (let d = 0; d < 31; d++) {
//   //   const day = new Date(2019, 1, d);
//   //   console.log(day.getDate() + ': ' + schedule.buildDatePlan(day));
//   // }
//   let plan = schedule.buildPlan(new Date(2019, 1, 0), new Date(2019, 2, 5));
//   for (let d of plan) {
//     const {date, order} = d;
//     console.log(date.getMonth() + ' ' + date.getDate() + ' ' + order);
//   }
//   // console.log(plan)
//   console.log('测试全部通过');
// }

function compareTo(a, b) {
  return a.getTime() - b.getTime()
}

class Schedule {
  static getWorkItemList(target,
    teamCount,
    cycleCount,
    startDateWithTime,
    endDateWithTime) {
    let workItems = [];

    let cycleTime = 24 * 60 * 60 * 1000 / cycleCount; // 每班的工作时间
    let diffTime = target.getTime() - startDateWithTime.getTime();
    let diffCycle = Math.ceil(diffTime / cycleTime); // 从开始到目标时间经历的工作轮次，向上取整
    let firstWorkTime = diffCycle * cycleTime + startDateWithTime.getTime();
    let firstWorkIndex = diffCycle % teamCount;
    for (let i = 0; i < cycleCount; i++) {
      let startTime = new Date(firstWorkTime + i * cycleTime);
      let endTime = new Date(firstWorkTime + (i + 1) * cycleTime);
      let workIndex = Math.floor((firstWorkIndex + i) % teamCount);
      // 判断起止时间是否在排班计划范围之内
      if (compareTo(startTime, startDateWithTime) >= 0 && compareTo(endTime, endDateWithTime) <= 0) {
        workItems.push({ start: startTime, end: endTime, teamIndex: workIndex });
      }
    }
    return workItems;
  }
}

export default Schedule;